import { render, staticRenderFns } from "./chooseGoodsItem.vue?vue&type=template&id=5a5025e3&scoped=true"
import script from "./chooseGoodsItem.vue?vue&type=script&lang=js"
export * from "./chooseGoodsItem.vue?vue&type=script&lang=js"
import style0 from "./chooseGoodsItem.vue?vue&type=style&index=0&id=5a5025e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5025e3",
  null
  
)

export default component.exports